import React from "react";
import "./About.css";

const About = () => {
  return (
    <>
      {/* Banner Section */}
      <div className="banner2-container">
        <div className="banner2-content">
          <h1>WE ARE ASTITVA LOGISTICS</h1>
          <p>India’s most reliable and lowest cost logistics service partner</p>
        </div>
      </div>

      {/* Introduction Section */}
      <div className="font-container">
        <h4>We are a trusted partner in simplifying logistics</h4>
        <p>
          Our aim is to streamline the logistics process - offering a smooth and
          efficient delivery experience, all while delivering excellent value by
          offering the lowest cost.
        </p>
        <p>
          Our commitment to achieving this goal is encapsulated in our very name—
          Astitva—a symbol of "Existence" and "Essence." The name reflects our
          dedication to providing value-driven logistics solutions and ensuring
          high-quality service for all our customers.
        </p>
      </div>

      {/* Mission & Vision Section */}
      <div className="mission-vision-container">
        <section className="mission">
          <h2>Our Mission</h2>
          <p>
            To deliver India’s most reliable and lowest cost supply chain logistics.
          </p>
        </section>
        <section className="vision">
          <h2>Our Vision</h2>
          <p>
            To create a future where logistics is effortless, reliable, offered at the best
            value, and accessible to all. Thus, allowing small and large businesses to focus on
            their business goals, while we handle the rest.
          </p>
        </section>
        <section className="who-are-we-serving">
          <h2>Who are we serving?</h2>
          <p>
            Currently, our customers consist of all sellers on the Meesho platform, spanning both
            well-established enterprises as well as dynamic small brands.
          </p>
        </section>
      </div>

      {/* Astitva Terms Section */}
      <div className="astitva-terms-container">
        <section className="astitva-term">
          <h2>Astitva Hub</h2>
          <p>
            All our first mile and last mile nodes will now be referred to as an "Astitva Hub."
            These are the seller/customer-facing nodes in our operations.
          </p>
        </section>
        <section className="astitva-term">
          <h2>Astitva Captains</h2>
          <p>
            The partners who own these Hubs will be known as Captains. These are people who
            own the first/last mile hubs and are responsible for all operations happening in these
            hubs.
          </p>
        </section>
        <section className="astitva-term">
          <h2>Astitva Pilots</h2>
          <p>
            Each first and last mile node will have pickup/delivery executives who interact with
            our sellers/customers on a day-to-day basis. These people will be known as Astitva Pilots,
            responsible for ensuring secure and timely pickup or delivery of the shipments.
          </p>
        </section>
        <section className="astitva-term">
          <h2>Astitva Base</h2>
          <p>
            All the middle nodes in our operations, including sort centers and cross docks, will
            be known as Astitva Base. These nodes will be critical in handling large-scale operations
            efficiently and providing the right direction to our shipments.
          </p>
        </section>
        <section className="astitva-term">
          <h2>Astitva Handlers</h2>
          <p>
            Given the large number of shipments being handled by people working in sort centers /
            cross docks, these sorting specialists will be known as Astitva Handlers.
          </p>
        </section>
      </div>
    </>
  );
};

export default About;